import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertProps,
  AlertTitle,
  AlertTitleProps,
  Box,
  CloseButton,
} from '@chakra-ui/react';
import { FC, ReactNode, useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { getDataTracking } from '../../utils';

export interface NotificationProps {
  hasClose?: boolean;
  message: string;
  messageCallback?: ReactNode;
  status?: AlertProps['status'];
  title?: AlertTitleProps['title'];
  trackingLabel?: string;
}

export const Notification: FC<NotificationProps> = ({
  hasClose,
  message,
  messageCallback,
  status,
  title,
  trackingLabel,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!!message);
  }, [message]);

  if (!visible) return null;
  return (
    <Alert status={status} aria-label={`${status}Alert`}>
      <AlertIcon />
      <Box flex="1">
        {title && <AlertTitle mr={2}>{title}</AlertTitle>}
        <AlertDescription>
          {parse(message || '')} {messageCallback}
        </AlertDescription>
      </Box>
      {hasClose && (
        <CloseButton
          {...getDataTracking(`${trackingLabel}${status}NotoficationClose`)}
          onClick={() => setVisible(false)}
          position="absolute"
          right={2}
          top={2}
        />
      )}
    </Alert>
  );
};
